import React, { useEffect, useRef } from "react";
import "../components/Contact.css";

export default function Contact() {
  const contactRef = useRef(null);
  const effectRef = useRef(null);

  useEffect(() => {
    const threeScript = document.createElement("script");
    threeScript.src =
      "https://cdn.jsdelivr.net/npm/three@0.124.0/build/three.min.js";
    threeScript.async = true;

    threeScript.onload = () => {
      const vantaScript = document.createElement("script");
      vantaScript.src =
        "https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.birds.min.js";
      vantaScript.async = true;

      vantaScript.onload = () => {
        if (!effectRef.current && window.VANTA?.BIRDS) {
          effectRef.current = window.VANTA.BIRDS({
            el: contactRef.current,
            THREE: window.THREE,
            backgroundColor: 0x000000,
            color1: 0xff00ff,
            color2: 0xffffff,
            birdSize: 0.5,
            wingSpan: 10.0,
            speedLimit: 1.0,
            separation: 150.0,
            alignment: 150.0,
            cohesion: 50.0,
            quantity: 6.0,
            scale: 1.0,
            scaleMobile: 0.8,
            mouseControls: true,
            touchControls: true,
          });
        }
      };

      document.body.appendChild(vantaScript);
    };

    document.body.appendChild(threeScript);

    return () => {
      effectRef.current?.destroy();
    };
  }, []);

  return (
    <section id="contact" className="contact" ref={contactRef}>
      <div className="contact-header" data-aos="fade-up">
        <h2>Contact Me</h2>
        <p>Let's build something amazing together.</p>
      </div>

      <form className="contact-form" data-aos="fade-up" data-aos-delay="100">
        <input type="text" placeholder="Your Name" required />
        <input type="email" placeholder="Your Email" required />
        <textarea rows="5" placeholder="Your Message" required />
        <button type="submit">Send Message</button>
      </form>
    </section>
  );
}
